import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SignalWifiConnectedNoInternet4Icon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"signal_wifi_connected_no_internet_4"} ref={ref}/>
});

SignalWifiConnectedNoInternet4Icon.displayName = "SignalWifiConnectedNoInternet4Icon";
